// Como uma decisão de follow-up vira frase na tela.
//
// O rastro é honesto e ilegível: `modelo:encerrar`, `regra:cliente_falou_por_ultimo`,
// `indefinido:condicoes`. Quem atende não deve precisar aprender esse vocabulário para
// responder "por que o agente parou de escrever para essa pessoa?".
//
// Fica em helper e não no componente porque o mesmo mapa vai ser lido pelo painel do
// agente — e um segundo mapa divergiria no primeiro dia.

// A chave é a FONTE, exatamente como o runtime a grava. Um `default` cobre o que ainda não
// foi traduzido: mostrar a fonte crua é feio e verdadeiro, e é melhor que uma frase genérica
// que esconde um caso novo.
const FRASES = {
  'regra:janela': 'Fora do horário permitido do agente',
  'regra:cliente_falou_por_ultimo': 'A última mensagem é do cliente',
  'regra:humano_na_conversa': 'Um atendente assumiu a conversa',
  'regra:followup_sem_resposta': 'Já houve follow-up sem resposta',
  'regra:so_saudacao': 'A conversa não passou de um cumprimento',
  'regra:sem_historico': 'Não há histórico para retomar',
  'modelo:liberou': 'Nenhuma condição descreve esta conversa',
  'modelo:adiar': 'Uma condição pediu para adiar',
  'modelo:encerrar': 'Uma condição encerrou o follow-up',
  'modelo:falhou': 'O modelo não respondeu',
  'modelo:resposta_invalida': 'O modelo respondeu algo inválido',
  'modelo:sem_orcamento': 'O agente bateu o teto de gasto do dia',
  'envio:feito': 'Mensagem de retomada enviada',
  'envio:repetido': 'A mensagem já havia sido enviada',
  'envio:sem_texto': 'O agente não conseguiu redigir a mensagem',
  'indefinido:condicoes': 'Aguardando avaliação das condições',
  indefinido: 'Nenhuma regra decidiu',
};

export function fraseDaDecisao(fonte) {
  return FRASES[fonte] || fonte;
}

// Três estados e não dois. "Autorizou e enviou" e "autorizou e NÃO enviou" são coisas
// diferentes: a segunda é a feature em observação, com o portão de envio fechado, e
// confundi-las faria a tela dizer que o cliente recebeu uma mensagem que nunca saiu.
export function estadoDaDecisao({ autorizado, enviado }) {
  if (enviado) return 'enviado';
  if (autorizado) return 'autorizado';
  return 'barrado';
}

export function ehDecisaoDeModelo(fonte) {
  return typeof fonte === 'string' && fonte.startsWith('modelo:');
}
